// STUDIO-OVERLAY-UI-CONSOLIDATION-1 · 판매자 전용 '현재 소개 상품' 확인 카드 (영상 합성 X · 송출 미반영).
// STUDIO-MOBILE-PRODUCT-BAR-UX-FIX-1 · 카드+송출 미리보기 한 줄 · 하단바 접힘(collapsed) 연동 이동 · ChevronUp(패널 열기).
import React from 'react';
import { ChevronUp, Radio } from 'lucide-react';
import SafeImg from '@/components/SafeImg';

const won = (n) => (Number.isFinite(Number(n)) ? `${Number(n).toLocaleString('ko-KR')}원` : '');

export const StudioCurrentProductCard = ({ product, onOpen, extPreview, onToggleExtPreview, collapsed = false }) => {
  if (!product) return null;
  const name = (product.name || '').replace(new RegExp(`^\\s*${product.slot_number || 'x'}번\\s*[·.\\-]?\\s*`), '');
  return (
    <div className="lg:hidden absolute left-3 z-[31] pointer-events-none flex items-end justify-end gap-2 transition-[bottom,right] duration-200 ease-out"
         style={{
           bottom: collapsed ? 'calc(env(safe-area-inset-bottom) + 1rem)' : 'calc(env(safe-area-inset-bottom) + 5.25rem)',
           right: collapsed ? 'calc(env(safe-area-inset-right) + 3.75rem)' : '0.75rem',
         }}
         data-testid="studio-current-product-card" data-collapsed={collapsed ? 'true' : 'false'}>
      {!extPreview && (
        <button type="button" onClick={onOpen}
                className="pointer-events-auto flex-1 min-w-0 flex items-center gap-2.5 p-2 pr-2.5 rounded-2xl bg-white/90 backdrop-blur-md border border-black/5 shadow-lg text-left transition-transform active:scale-[0.99]"
                aria-label="상품 패널 열기" data-testid="studio-current-product-open">
          <SafeImg src={product.image} kind="product" alt="" className="w-10 h-10 rounded-xl object-cover shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-[11px] font-black text-[#FF3B30] leading-tight" data-testid="studio-current-product-status">
              소개 중{product.slot_number ? ` · ${product.slot_number}번` : ''}
            </p>
            <p className="text-[13px] font-black text-gray-900 truncate leading-tight" data-testid="studio-current-product-name">{name || product.name}</p>
            <p className="text-[13px] font-black text-gray-900 leading-tight" data-testid="studio-current-product-price">{won(product.sale_price ?? product.price)}</p>
          </div>
          <ChevronUp size={18} className="text-gray-400 shrink-0" data-testid="studio-current-product-chevron-up" />
        </button>
      )}
      {onToggleExtPreview && (
        <button type="button" onClick={onToggleExtPreview}
                className={`pointer-events-auto shrink-0 w-[60px] h-14 rounded-2xl text-[10px] font-black leading-tight inline-flex flex-col items-center justify-center gap-0.5 shadow-lg border transition-colors ${
                  extPreview ? 'bg-[#FF3B30] text-white border-[#FF3B30]' : 'bg-white/90 text-gray-800 border-black/10 backdrop-blur-md'}`}
                aria-pressed={extPreview} aria-label={extPreview ? '외부 송출 Overlay 미리보기 닫기' : '외부 송출 Overlay 미리보기'}
                data-testid="studio-ext-preview-toggle">
          <Radio size={14} />
          <span className="whitespace-pre-line text-center">{extPreview ? '미리보기\n닫기' : '송출\n미리보기'}</span>
        </button>
      )}
    </div>
  );
};

export default StudioCurrentProductCard;
